import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import {Observable} from "rxjs";

@Injectable()
export class LegalInfoService {

  apiEndpoint = 'api';
  constructor(
    private httpClient: HttpClient
  ) {}


  list(): Observable<any> {

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    let httpParams = new HttpParams().set('category', 'some category');

    return this.httpClient.get('../assets/data/legal.json', {
      responseType: 'json',
      params: httpParams,
      headers: httpHeaders
    });

  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/legal-info.service.ts